import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WayneEnterprises from "./components/WayneEnterprises/WayneEnterprises";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WayneEnterprises />} />
      </Routes>
    </Router>
  );
}

export default App;